module.exports = __webpack_public_path__ + "static/media/click-to-luck-btn.f9c2b515.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/click-to-luck-btn.png
// module id = 1848
// module chunks = 6